/**
 * Add a letter at the end of URL
 */
document.addEventListener('click', (e) => {
	if (e.target && e.target.tagName == 'BUTTON' && e.target.getAttribute('data-letter')) {
		let lt = e.target.getAttribute('data-letter')
		window.location.href = window.location.href.split('#')[0] + lt;
	}
})

/**
 * Navigate to a specific tab based on the URL fragment. (like #A)
 */
document.addEventListener('DOMContentLoaded', () => {
	if (window.location.hash && document.querySelector('.ouw-glossary')) {
		if (/^#[A-Z]$/.test(window.location.hash)) {
			[...document.querySelectorAll('.ouw-glossary .accordion-button')].forEach(element => {
				element.classList.add('collapsed');
				element.setAttribute('aria-expanded', false)
			});
			[...document.querySelectorAll('.ouw-glossary .accordion-collapse')].forEach(element => {
				element.classList.remove('show');
			});
			let letter = window.location.hash
			let btn = document.querySelector('.accordion-button[data-letter="'+letter+'"]')
			if (btn) {
				btn.classList.remove('collapsed')
				btn.setAttribute('aria-expanded', true)
				document.querySelector('#collapse'+letter.replace('#', '')+'.accordion-collapse').classList.add('show')
			}
		}
	}
})